import React from 'react';
import { cn } from '@/utils/сn';

export const Divider = (props: { className?: string }) => {
  const { className } = props;
  return <div className={cn('mx-7.5 my-7.5 h-px bg-blue-100', className)} />;
};
